import React from "react";
import styles from "./Field.module.css";

type Props = {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (v: string) => void;
  error?: string;
  rightIcon?: boolean;
  inputMode?: React.InputHTMLAttributes<HTMLInputElement>["inputMode"];
  type?: React.InputHTMLAttributes<HTMLInputElement>["type"];
  name?: string;
  autoComplete?: string;
  disabled?: boolean;
};

export default function Field({
  label,
  placeholder,
  value,
  onChange,
  error,
  rightIcon,
  inputMode,
  type = "text",
  name,
  autoComplete,
  disabled,
}: Props) {
  const id = React.useId();

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>

      <div className={styles.inputWrap}>
        <input
          id={id}
          name={name}
          className={[styles.input, error ? styles.inputError : ""].join(" ")}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          inputMode={inputMode}
          type={type}
          autoComplete={autoComplete}
          disabled={disabled}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        />
        {rightIcon ? <span className={styles.iconDot}>◦</span> : null}
      </div>

      {error ? (
        <div id={`${id}-error`} className={styles.errorText}>
          {error}
        </div>
      ) : null}
    </div>
  );
}
